import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconModelOnDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6364 3.63636C15.6364 5.64467 14.0083 7.27273 12 7.27273C9.99169 7.27273 8.36364 5.64467 8.36364 3.63636C8.36364 1.62806 9.99169 0 12 0C14.0083 0 15.6364 1.62806 15.6364 3.63636Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6364 20.3636C15.6364 22.3719 14.0083 24 12 24C9.99169 24 8.36364 22.3719 8.36364 20.3636C8.36364 18.3553 9.99169 16.7273 12 16.7273C14.0083 16.7273 15.6364 18.3553 15.6364 20.3636Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.63636 15.6364C5.64467 15.6364 7.27273 14.0083 7.27273 12C7.27273 9.99169 5.64467 8.36364 3.63636 8.36364C1.62806 8.36364 0 9.99169 0 12C0 14.0083 1.62806 15.6364 3.63636 15.6364Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 12C24 14.0083 22.3719 15.6364 20.3636 15.6364C18.3553 15.6364 16.7273 14.0083 16.7273 12C16.7273 9.99169 18.3553 8.36364 20.3636 8.36364C22.3719 8.36364 24 9.99169 24 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.34805 7.16622C9.41906 7.23723 9.41906 7.35235 9.34805 7.42335L7.42336 9.34804C7.35236 9.41905 7.23724 9.41905 7.16623 9.34804L6.65197 8.83378C6.58097 8.76278 6.58097 8.64766 6.65197 8.57665L8.57666 6.65196C8.64767 6.58096 8.76279 6.58096 8.83379 6.65196L9.34805 7.16622Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8182 12.3636C15.8182 12.4641 15.7368 12.5455 15.6364 12.5455H8.36365C8.26324 12.5455 8.18183 12.4641 8.18183 12.3636V11.6364C8.18183 11.536 8.26324 11.4546 8.36365 11.4546H15.6364C15.7368 11.4546 15.8182 11.536 15.8182 11.6364V12.3636Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4234 17.348C15.3524 17.419 15.2372 17.419 15.1662 17.348L14.652 16.8338C14.581 16.7628 14.581 16.6477 14.652 16.5767L16.5767 14.652C16.6477 14.581 16.7628 14.581 16.8338 14.652L17.3481 15.1662C17.4191 15.2372 17.4191 15.3524 17.3481 15.4234L15.4234 17.348Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.652 7.16622C14.581 7.23723 14.581 7.35235 14.652 7.42335L16.5767 9.34804C16.6477 9.41905 16.7628 9.41905 16.8338 9.34804L17.3481 8.83378C17.4191 8.76278 17.4191 8.64766 17.3481 8.57665L15.4234 6.65196C15.3524 6.58096 15.2372 6.58096 15.1662 6.65196L14.652 7.16622Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.57667 17.348C8.64767 17.419 8.7628 17.419 8.8338 17.348L9.34806 16.8338C9.41906 16.7628 9.41906 16.6477 9.34806 16.5767L7.42337 14.652C7.35237 14.581 7.23725 14.581 7.16624 14.652L6.65198 15.1662C6.58098 15.2372 6.58098 15.3524 6.65198 15.4234L8.57667 17.348Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconModelOnDark as ReactComponent };
